export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
            数据见证实力
          </h2>
          <p className="text-sm md:text-base text-background-400 max-w-2xl mx-auto leading-relaxed">
            每一个数字背后，都是91传媒对品质的坚持和对客户的承诺
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {[
            { value: '1,280', unit: '万', label: '累计服务内容创作者', icon: 'ri-user-star-line' },
            { value: '356', unit: '个', label: '品牌合作项目完成', icon: 'ri-briefcase-line' },
            { value: '12.8', unit: '亿', label: '内容年度总曝光量', icon: 'ri-flashlight-line' },
            { value: '47', unit: '个', label: '覆盖行业细分领域', icon: 'ri-global-line' },
          ].map((stat) => (
            <div key={stat.label} className="text-center p-6 rounded-xl bg-background-900/50 border border-background-800/60">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400 mb-4">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
                <span className="text-lg md:text-xl font-normal text-background-400 ml-1">{stat.unit}</span>
              </div>
              <div className="text-xs md:text-sm text-background-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}